import React from 'react';
import { Navigate } from 'react-router-dom';
import type { Permission } from '@/access-control.config';
import { useAuth } from './AuthProvider';

export interface GuardedRouteProps {
    allow?: Permission | Permission[];
    mode?: 'any' | 'all';
    fallback?: React.ReactNode;
    children: React.ReactNode;
}

export function GuardedRoute({ allow, mode = 'any', fallback, children }: GuardedRouteProps) {
    const { hasPermission } = useAuth();

    const allowed = allow ? hasPermission(allow, mode) : true;

    if (!allowed) {
        if (fallback) {
            return <>{fallback}</>;
        }
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
}
